import React, { useEffect, useState } from 'react';
import Constants from 'expo-constants';
import { ScrollView } from 'react-native';
import { COMPLETE_SIGN_UP } from '../../auth/authTypes';
import { useAuthDispatch, useAuthState } from '../../auth/authContext';
import { SET_FAN_GENRES } from '../../fanContext/fanTypes';
import { useFanDispatch } from '../../fanContext/fanContext';
import Text from '../../components/styled/Text';
import client from '../../../graphql/client';
import View from '../../components/styled/View';
import FanGenreButtonList from '../../components/styled/FanGenreButtonList';
import GalanoGrotesqueText from '../../components/styled/GalanoGrotesqueText';
import GenreButton from '../../components/styled/GenreButton';
import LinearGradientButton from '../../components/styled/LinearGradientButton';
import styles from './styles';

export default function FanGenresScreen({ navigation, route }) {
  const isBetaEnv = Constants.manifest.extra.environment === 'beta';

  const { cognitoId } = useAuthState();
  const dispatch = useAuthDispatch();
  const fanDispatch = useFanDispatch();
  const values = route.params.formikValues;
  const favGenres = route?.params?.favoriteGenres;
  const isCreate = route.params.isCreate;

  const [updatedGenres, setUpdatedGenres] = useState(favGenres || []);
  const [genresList, setGenres] = useState<any>();

  useEffect(() => {
    createGenreList();
  }, []);

  const createGenreList = async () => {
    const rawGenreData = await client.getSuperGenres();
    const genreData = rawGenreData.items;

    // TODO: Remove after private beta: https://app.shortcut.com/tone-birds/story/471/remove-genre-restriction-for-fans-after-private-beta
    if (isBetaEnv) {
      const privateBetaGenres = genreData.filter((x) => {
        return (
          x.superGenre === 'Pop' ||
          x.superGenre === 'Electronic' ||
          x.superGenre === 'Indie'
        );
      });
      setGenres(privateBetaGenres);
      setUpdatedGenres(privateBetaGenres);
    } else {
      setGenres(genreData);
    }
    // =============================================
  };

  // TODO: REMOVE after apollo added
  const updateFanGenreConnection = async () => {
    //build fanId, genreId object and await then push
    if (isCreate) {
      updatedGenres.map(async (genre) => {
        const fanGenreObj = {
          fanGenreFanId: cognitoId,
          fanGenreGenreId: genre.id,
        };
        await client.createAFanGenre(fanGenreObj);
      });
    } else {
      await Promise.all(
        favGenres.map(async (fanGenre) => {
          await client.deleteAFanGenre({ id: fanGenre.fgId });
        }),
      );
      await Promise.all(
        updatedGenres.map(async (genre) => {
          const fanGenreObj = {
            fanGenreFanId: cognitoId,
            fanGenreGenreId: genre.id,
          };
          await client.createAFanGenre(fanGenreObj);
        }),
      );
      navigation.navigate('MyAccount', { newGenres: updatedGenres });
    }
    fanDispatch({
      type: SET_FAN_GENRES,
      genres: updatedGenres,
    });
  };

  const saveProfile = async () => {
    const { fullName, zipCode } = values;
    const fanDetails = {
      cognitoId,
      fullName,
      zipCode,
      isReturningFan: false,
    };
    await client.createAFan(fanDetails);
    // Add genre connections
    await updateFanGenreConnection();
    try {
      dispatch({
        type: COMPLETE_SIGN_UP,
      });
      navigation.replace('Fan', { screen: 'Listen' });
    } catch (e) {
      console.error(e);
    }
  };

  const updateNewGenres = (selectedGenre: any) => {
    const clonedGenres = updatedGenres.slice(); // ensures we don't mutate the original array
    const indexToRemove = clonedGenres.findIndex(
      (item) => item.id === selectedGenre.id,
    );
    clonedGenres.find((item) => item?.id == selectedGenre.id)
      ? clonedGenres.splice(indexToRemove, 1)
      : clonedGenres.push({
          id: selectedGenre.id,
          genre: selectedGenre.genre,
          fgId: 'new',
        });
    setUpdatedGenres(clonedGenres);
  };

  if (!genresList) return null;
  const limitReached = updatedGenres.length === 3;

  const minSelectedThreshold = updatedGenres.length === 1;

  // TODO: Remove after private beta: https://app.shortcut.com/tone-birds/story/471/remove-genre-restriction-for-fans-after-private-beta
  if (isBetaEnv) {
    return (
      <ScrollView contentContainerStyle={{ flex: 1 }}>
        <View style={styles.container}>
          <Text style={styles.title}>Genres</Text>
          <GalanoGrotesqueText style={styles.privateBetaText}>
            For the private beta test we have pre-selected three genres. Please
            click "Save" below to proceed.
          </GalanoGrotesqueText>
          <View style={styles.genreList}>
            <View style={{ flexDirection: 'row' }}>
              {genresList.map((privateBetaGenres) => {
                return (
                  <GenreButton
                    key={privateBetaGenres.id}
                    isActive
                    genreObj={privateBetaGenres}
                    minSelectedThreshold
                    limitReached={limitReached}
                    onPress={() => {}}
                  />
                );
              })}
            </View>
          </View>
          {!isCreate && (
            <LinearGradientButton
              title="Save"
              onPress={updateFanGenreConnection}
            />
          )}
          {isCreate && (
            <LinearGradientButton title="Save" onPress={saveProfile} />
          )}
        </View>
      </ScrollView>
    );
  }
  // ===========================================================

  return (
    <ScrollView contentContainerStyle={{ flex: 1 }}>
      <View style={styles.container}>
        <Text style={styles.title}>3 Favorite Genres</Text>
        <View style={styles.genreList}>
          <FanGenreButtonList
            genres={genresList}
            activeGenres={updatedGenres}
            onPress={updateNewGenres}
            limitReached={limitReached}
            minSelectedThreshold={minSelectedThreshold}
          />
        </View>
        {!isCreate && (
          <LinearGradientButton
            title="Save"
            onPress={updateFanGenreConnection}
          />
        )}
        {isCreate && (
          <LinearGradientButton title="Save" onPress={saveProfile} />
        )}
      </View>
    </ScrollView>
  );
}
